import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { WebSocketService } from '../websocketService';

interface WebSocketContextValue {
  service: WebSocketService;
  isConnected: boolean;
}

const WebSocketContext = createContext<WebSocketContextValue | null>(null);

export const WebSocketProvider: React.FC<{
  url: string;
  heartbeatIntervalMs: number;
  children: React.ReactNode;
}> = ({ url, heartbeatIntervalMs, children }) => {
  const wsClientRef = useRef<WebSocketService | null>(null);
  const [isConnected, setIsConnected] = useState(false);

  if (!wsClientRef.current) {
    wsClientRef.current = new WebSocketService(url, heartbeatIntervalMs);
  }

  useEffect(() => {
    const wsClient = wsClientRef.current;
    if (!wsClient) return;

    wsClient.onOpen(() => {
      console.log('[WebSocketProvider] Connection opened');
      setIsConnected(true);
    });

    wsClient.onClose(() => {
      console.log('[WebSocketProvider] Connection closed');
      setIsConnected(false);
    });

    wsClient.connect();

    return () => {
      wsClient.disconnect();
      setIsConnected(false);
    };
  }, [url]);

  return (
    <WebSocketContext.Provider
      value={{ service: wsClientRef.current, isConnected }}
    >
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => {
  console.log('[WebSocketProvider][useWebSocket][ENTRY]');
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error('useWebSocket must be used within a WebSocketProvider');
  }
  console.log('[WebSocketProvider][useWebSocket][EXIT]', {
    isConnected: context.isConnected,
  });
  return context;
};
